import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'

import { authApi } from '../..'
import {
  GetIntermediateLoginTokenRequest,
  GetIntermediateLoginTokenResponse
} from './getIntermediateLoginToken.types'

export const getIntermediateLoginToken = async (
  request: GetIntermediateLoginTokenRequest
) => {
  const response = await authApi.post<GetIntermediateLoginTokenResponse>(
    '/get-intermediate-login-token',
    {
      ...request,
      crm_employee_id: -1,
      application_id: -1
    }
  )
  return response.data
}

export const useGetIntermediateLoginTokenMutation = (
  options?: ExtendableMutationOptions<
    GetIntermediateLoginTokenResponse,
    GetIntermediateLoginTokenRequest
  >
) => {
  return useMutation({
    mutationFn: getIntermediateLoginToken,
    ...options
  })
}
